export const ALL_SUCURSALES = 'all';

const normalizeSucursalId = (sucursal) =>
  String(sucursal?.id || sucursal?.sucursal_id || '').trim();

const normalizeSucursal = (sucursal) => {
  const id = normalizeSucursalId(sucursal);
  if (!id) return null;
  return {
    ...sucursal,
    id,
    nombre: sucursal?.nombre || `Sucursal #${id}`,
  };
};

export function buildSucursalFilterOptions({
  sucursalActiva,
  sucursalPrincipal,
  sucursalesHabilitadas = [],
} = {}) {
  const activeId = normalizeSucursalId(sucursalActiva);
  const unique = new Map();

  [sucursalActiva, sucursalPrincipal, ...sucursalesHabilitadas].forEach((sucursal) => {
    const normalized = normalizeSucursal(sucursal);
    if (normalized) unique.set(normalized.id, normalized);
  });

  const active = activeId ? unique.get(activeId) : null;
  const remaining = Array.from(unique.values())
    .filter((sucursal) => sucursal.id !== activeId)
    .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es'));

  return [
    ...(active ? [{ ...active, current: true }] : []),
    { id: ALL_SUCURSALES, nombre: 'Todas las sucursales habilitadas', all: true },
    ...remaining,
  ];
}

export function createDefaultInvoiceFilters(sucursalActiva) {
  const currentMonth = resolveQuickPeriod('este_mes');
  return {
    search: '',
    cliente: '',
    desde: currentMonth.desde,
    hasta: currentMonth.hasta,
    sucursalId: normalizeSucursalId(sucursalActiva),
    tipo: '',
    estado: '',
    saldo: '',
    periodo: 'este_mes',
    origen: '',
    condicionVenta: '',
    usuarioId: '',
    puntoVenta: '',
    cae: '',
    anuladas: '',
    sort: 'emision',
    order: 'desc',
  };
}

const toDateInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export function resolveQuickPeriod(period, now = new Date()) {
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let start = new Date(end);
  if (period === 'hoy') return { desde: toDateInput(start), hasta: toDateInput(end) };
  if (period === 'semana') {
    const day = start.getDay() || 7;
    start.setDate(start.getDate() - day + 1);
  } else if (period === 'este_mes') {
    start = new Date(end.getFullYear(), end.getMonth(), 1);
  } else if (period === 'mes_anterior') {
    start = new Date(end.getFullYear(), end.getMonth() - 1, 1);
    end.setDate(0);
  } else {
    return { desde: '', hasta: '' };
  }
  return { desde: toDateInput(start), hasta: toDateInput(end) };
}

export function countActiveInvoiceFilters(filters, sucursalActiva) {
  const defaults = createDefaultInvoiceFilters(sucursalActiva);
  return Object.entries(filters || {}).reduce(
    (count, [key, value]) => count + (String(value || '') !== String(defaults[key] || '') ? 1 : 0),
    0,
  );
}
